if (!customElements.get('quantity-bundles')) {
  customElements.define(
    'quantity-bundles',
    class QuantityBundles extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));
        if (!this.radios.length) return;
        this.addEventListener('change', () => this.apply());
        this.apply();
      }

      get selected() {
        return this.radios.find((radio) => radio.checked) || this.radios[0];
      }

      apply() {
        const selected = this.selected;
        if (!selected) return;
        const quantity = parseInt(selected.value, 10) || 1;

        this.updateQuantityInput(quantity);
        this.updateSubmitButton(selected);
        this.updateKlarna(selected);
        this.updateSticky(selected);
      }

      updateQuantityInput(quantity) {
        const formIds = ['product-form-' + this.sectionId, 'product-form-' + this.sectionId + '--alt'];
        formIds.forEach((formId) => {
          const form = document.getElementById(formId);
          if (!form) return;
          let input = form.querySelector('input[name="quantity"]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'quantity';
            form.appendChild(input);
          }
          if (input.value === String(quantity)) return;
          input.value = quantity;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateSticky(selected) {
        const label = document.querySelector('[data-sticky-bundle-label]');
        if (label) label.textContent = selected.dataset.stickyLabel || '';
        const total = document.querySelector('[data-sticky-total]');
        if (total) total.textContent = selected.dataset.total || '';
      }

      updateSubmitButton(selected) {
        if (this.dataset.updateButton !== 'true') return;
        const button = document.getElementById('ProductSubmitButton-' + this.sectionId);
        const label = button ? button.querySelector('span') : null;
        if (!label || button.disabled) return;
        if (!this.baseLabel) this.baseLabel = label.textContent.trim();
        label.textContent = this.baseLabel + ' — ' + selected.dataset.total;
      }

      updateKlarna(selected) {
        if (!selected.dataset.klarnaAmount) return;
        const text = document.querySelector(
          '#Klarna-' + this.sectionId + ' .product-klarna__text[data-template]'
        );
        if (!text) return;
        text.textContent = text.dataset.template
          .replace('[bedrag]', selected.dataset.klarnaAmount)
          .replace('[delen]', text.dataset.parts);
      }
    }
  );
}
